module.exports = __webpack_public_path__ + "media/images/emblems/Herbligen-coat_of_arms-d1ac18047ede77e1bc56eaaab4ba3d19.svg";